<template>
  <div class="contentBox">
    <div class="container">
      <div class="article auto-height">
        <div class="text page-title">Yêu cầu hủy tài khoản game</div>
        <p class="strong">Đăng nhập tài khoản nền tảng đã liên kết với game</p>
        <div class="text">
          Người chơi thân mến, để đảm bảo an toàn cho tài khoản của bạn, vui
          lòng đăng nhập vào bất kỳ tài khoản nền tảng nào đã liên kết với tài
          khoản game mà bạn muốn hủy.
        </div>
        <div class="input-outer">
          <div class="input-wrap">
            <input
              placeholder="Email / phone"
              type="text"
              class="input-item"
              maxlength="30"
              v-model="username"
            />
            <span
              v-if="username"
              class="clear-icon"
              @click="username = ''"
            ></span>
          </div>
        </div>
        <div class="input-outer">
          <div class="input-wrap">
            <input
              placeholder="Password"
              type="password"
              class="input-item"
              maxlength="30"
              v-model="password"
            />
            <span
              v-if="password"
              class="clear-icon"
              @click="password = ''"
            ></span>
          </div>
        </div>
        <!-- 使用 :class 动态绑定 active 类 -->
        <div
          class="btn mt auto-footer unactive"
          :class="{ active: isFormValid }"
          @click="handleClick()"
        >
          Login
        </div>
      </div>
    </div>
    <div data-v-0186101b="" class="mt-logo"></div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      username: "",
      password: "",
    };
  },
  computed: {
    // 计算属性：判断表单是否有效
    isFormValid() {
      return this.username.trim() && this.password.trim();
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleClick() {
      let game_id = this.$route.query.g;
      let params = {
        username: this.username,
        password: this.password,
        game_id,
      };
      this.$http.post("/login/doLogin", params).then((res) => {
        if (res.data.code === 200) {
          this.handleCheck(res.data.data.token);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleCheck(token) {
      this.$router.push({
        path: "/main/deletion/isDeleteAccount",
        query: {
          t: token,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "./css/index.css";
</style>
